import PayrollIntegrationsService from '@/services/payroll-integrations.service';
import { useQuery } from '@tanstack/react-query';

export default function useCompanyInfo(
  sponsorPlanId: number,
  isApiPlan: boolean
) {
  return useQuery(
    ['PayrollIntegrationsService.getCompanyInfo', sponsorPlanId],
    () => PayrollIntegrationsService.getCompanyInfo(sponsorPlanId),
    {
      enabled: isApiPlan
    }
  );
}
